import image03 from "../images/content-master/03.jpg";
import imageWebp03 from "../images/content-master/03.webp";

import image02 from "../images/content-master/02.jpeg";
import imageWebp02 from "../images/content-master/02.webp";

import image11 from "../images/content-master/11.jpg";
import imageWebp11 from "../images/content-master/11.webp";


const contentMaster = [
    {
        id: "01",
        title: "Crea personajes para videojuegos",
        image: image11,
        imageWebp: imageWebp11,
        description:
            "Inicia tu entrenamiento en la creación de personajes para videojuegos desde cero y llévalo a Unreal Engine 5",
        video: 'https://www.youtube.com/watch?v=qiMF5Z-5cwY'
    },
    {
        id: "02",
        title: "Domina la escultura en ZBrush",
        image: image02,
        imageWebp: imageWebp02,
        description:
            "Consolida tu conocimiento en ZBRUSH y prepárate para llegar al siguiente nivel.",
        video: 'https://www.youtube.com/watch?v=1-AWvUlYT6c'
    },
    {
        id: "03",
        title: "Da tus primeros pasos en ZBrush y crea tu primer modelo 3D",
        image: image03,
        imageWebp: imageWebp03,
        description:
            "Une la escultura y el modelado 3D para la creación de personaje femenino HARDSURFACE.",
        video: 'https://www.youtube.com/watch?v=_02iVwahe_A'
    }
];

export default contentMaster;